// 获取不同环境的appkey，appSecret，serviece前缀，埋点
export const getEnvObj = () => {
  const env = process.env.VUE_APP_ENV
  if (env === 'development') { // 开发环境
    return {
      ENV: window._global.ENV,
      SF_CAPTCHA_APP_ID: window._global.SF_CAPTCHA_APP_ID,
      SF_CAPTCHA_BASE_URL: window._global.SF_CAPTCHA_BASE_URL,
      SF_CAPTCHA_URL: window._global.SF_CAPTCHA_URL,
      OWT_URL_JP: window._global.OWT_URL_JP,
      OWT_URL_CN: window._global.OWT_URL_CN,
      OWT_URL_CN_LOGINING: window._global.OWT_URL_CN_LOGINING,
      SSO_LOGIN_URL: window._global.SSO_LOGIN_URL,
      IUOP_URL: window._global.IUOP_URL,
      // WEBFUNNY: window._global.WEBFUNNY,
      APP_KEY: window._global.APP_KEY,
      APP_SECRET: window._global.APP_SECRET,
      API_ICAS_AUTH: window._global.API_ICAS_AUTH,
      API_ICAS_SERVICE: window._global.API_ICAS_SERVICE,
      API_TIJI: window._global.API_TIJI,
      API_ICAS_RBAC: window._global.API_ICAS_RBAC,
      LOGGER_ACCESS_KEY: window._global.LOGGER_ACCESS_KEY,
      LOGGER_SECRECT_KEY: window._global.LOGGER_SECRECT_KEY,
      LOGGER_URL: window._global.LOGGER_URL,
      CURRENT_SITE: window._global.CURRENT_SITE,
      SITE: {
        OS: 'http://localhost:7080',
        CN: 'http://localhost:7080',
        US: 'http://localhost:7080',
        SG: 'http://localhost:7080',
      }
    }
  }
  let SSO_LOGIN_URL = ''
  if (window.location.origin === 'http://ibu-icas-w.sit.sf-express.com:9099') {
    SSO_LOGIN_URL = 'http://ibu-icas-w.sit.sf-express.com:9099'
  } else {
    SSO_LOGIN_URL = window._global.SSO_LOGIN_URL
  }
  return {
    ENV: window._global.ENV,
    SF_CAPTCHA_APP_ID: window._global.SF_CAPTCHA_APP_ID,
    SF_CAPTCHA_BASE_URL: window._global.SF_CAPTCHA_BASE_URL,
    SF_CAPTCHA_URL: window._global.SF_CAPTCHA_URL,
    OWT_URL_JP: window._global.OWT_URL_JP,
    OWT_URL_CN: window._global.OWT_URL_CN,
    OWT_URL_CN_LOGINING: window._global.OWT_URL_CN_LOGINING,
    SSO_LOGIN_URL,
    IUOP_URL: window._global.IUOP_URL,
    // WEBFUNNY: window._global.WEBFUNNY,
    APP_KEY: window._global.APP_KEY,
    APP_SECRET: window._global.APP_SECRET,
    API_ICAS_AUTH: window._global.API_ICAS_AUTH,
    API_ICAS_SERVICE: window._global.API_ICAS_SERVICE,
    API_TIJI: window._global.API_TIJI,
    API_ICAS_RBAC: window._global.API_ICAS_RBAC,
    LOGGER_ACCESS_KEY: window._global.LOGGER_ACCESS_KEY,
    LOGGER_SECRECT_KEY: window._global.LOGGER_SECRECT_KEY,
    LOGGER_URL: window._global.LOGGER_URL,
    CURRENT_SITE: window._global.CURRENT_SITE,
    SITE: window._global.SITE || {}
  }
}
